import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/detail',
    component: LAYOUT,
    meta: { title: '文章详情', hide: true },
    children: [
      {
        path: ':id',
        component: () => import('@/views/detail/detail.vue'),
        meta: { title: '文章详情', hide: true },
      },
    ],
  },
]
